import * as React from 'react';
import InvChoicesButtons from '../Controls/InvChoices/InvChoicesButtons';
import InvChoicesSlider from '../Controls/InvChoices/InvChoicesSlider';
import OnboardNote from '../OnboardNote/OnboardNote';
import Why from './Why';
import choicesIllustration from '../../assets/images/choices-illustration.svg';
import { FundTypes } from '../../models';

interface WalkthroughChoicesProps {
  capitalFund: FundTypes | null;
  digitalFund: FundTypes | null;
  allocation: number;
  setAllocation: (x: number) => object;
  setCapitalFund: (x: FundTypes) => object;
  setDigitalFund: (x: FundTypes) => object;
  next: () => void
  previous: () => void
  skip: () => void
}

const truncated = (): JSX.Element => (<h2>Your investment choices</h2>)
const expanded = (): JSX.Element => (
  <div>
    <h3>Digital Funds</h3>
    <p>These track an index of the top ten crypto assets by market capitalisation.</p>
    <p>A passive strategy moves the invested funds between exposure to the index and a cash equivalent to manage risk based on market conditions.</p>
    <h3>Capital Funds</h3>
    <p>These funds combine a global equity ETF, to provide growth, with short exchange-traded equity index futures to reduce the risk by reducing market exposure.</p>
    <p>The decisions about the balance between them are made by a machine learning framework.</p>
  </div>
);

class WalkthroughChoices extends React.Component<WalkthroughChoicesProps> {
  public render () {
    return (
      <div className='walkthrough-steps'>
        <Why
          colour='grey'
          illustration={choicesIllustration}
          previous={this.props.previous}
          skip={this.props.skip}
          expanded={expanded()}
          truncated={truncated()} />
        <div className='walkthrough-how'>
          <div className='how-inner'>
            <div className='digital-fund-note'>
              <OnboardNote positionX='left' positionY='top'>
                <p>You can select one digital fund based on the level of risk you're willing to accept.</p>
              </OnboardNote>
            </div>
            <InvChoicesButtons
              capitalFundSelected={this.props.capitalFund}
              digitalFundSelected={this.props.digitalFund}
              setDigitalFund={this.props.setDigitalFund}
              setCapitalFund={this.props.setCapitalFund}
              showTooltips={true}
            />
            <div className='capital-fund-note'>
              <OnboardNote positionX='right' positionY='bottom'>
                <p>And one capital fund.</p>
              </OnboardNote>
            </div>
          </div>
          <div className='how-inner'>
            <div className='allocation-note'>
              <OnboardNote positionX='left' positionY='top'>
                <p>You can choose how to weight your overall investment between the digital and capital funds you have selected.</p>
              </OnboardNote>
            </div>
            <InvChoicesSlider
              allocation={this.props.allocation}
              setAllocation={this.props.setAllocation}
              enabled={!!(this.props.capitalFund && this.props.digitalFund)}
            />
          </div>
          <button onClick={this.props.skip} className='button primary-button'>You're ready. Let's go to the graph!</button>
        </div>
      </div>
    );
  }
}

export default WalkthroughChoices;
